import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col, VertModal, VertTypography } from '@vertem-core/vertice-ds';
import { pointsMask } from 'Utils/maskFormat';
import { getObjectByKey } from 'Utils/getObjectByKey';
import { useDispatch, useSelector } from 'react-redux';
import { productPageMocks } from 'pages/productPage/mocks';
import generateUUID from 'Utils/generateUUID';
import {
  cardBrandAsync,
  resetCardBrands,
} from 'redux/Reducers/CardBrand/cardBrandSlice';
import CardBrand from 'components/Checkout/CheckoutPayment/PaymentScoreMoreMoney/components/CardBrand';

const ModalPointsCash = ({ open = false, handleClose }) => {
  const { cardBrands } = useSelector(({ CardBrandReducer: data }) => data);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(cardBrandAsync());

    return () => {
      dispatch(resetCardBrands());
    };
  }, []);

  return (
    <VertModal
      open={open}
      className="redemption-options-modal"
      onCancel={handleClose}
      title={<h1>Pontos + dinheiro</h1>}
      template="marketplace"
      spacing="regular"
    >
      <div className="redemption-options-content">
        <VertTypography.Paragraph>
          Não tem pontos suficientes para fazer o resgate? Sem problemas!
        </VertTypography.Paragraph>

        <VertTypography.Paragraph>
          Você pode pagar sua compra com os pontos que tem e completar o valor
          usando seu cartão de crédito.
        </VertTypography.Paragraph>

        <VertTypography.Paragraph className="label">
          Veja essas sugestões para você resgatar:
        </VertTypography.Paragraph>

        <Col>
          <VertTypography.Paragraph>
            Na etapa de pagamento, você poderá definir outras combinações entre
            pontos e cartão de crédito.
          </VertTypography.Paragraph>
        </Col>

        <div className="divider" />

        <div className="cards-accepted">
          <VertTypography.Paragraph className="label">
            Bandeiras aceitas
          </VertTypography.Paragraph>

          <div className="cards-images">
            {cardBrands.map(({ imageUrl, name }, index) => (
              <CardBrand imageUrl={imageUrl} key={index} name={name} />
            ))}
          </div>
        </div>

        <div className="divider" />

        <VertTypography.Paragraph className="label">
          Parcelamento
        </VertTypography.Paragraph>
        <VertTypography.Paragraph>
          Em até 3 vezes sem juros.
        </VertTypography.Paragraph>
      </div>
    </VertModal>
  );
};
ModalPointsCash.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
};

export default ModalPointsCash;
